import { render, staticRenderFns } from "./GeneralReceiptForm.vue?vue&type=template&id=22c6932e"
import script from "./GeneralReceiptForm.vue?vue&type=script&lang=js"
export * from "./GeneralReceiptForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports